import { ApiClient } from '@bustickus/api';
import { IClientTripFull, IClientTripMonthPricesBrief, IClientTripSearchFull } from '@bustickus/models-client';
import { createApiAddress, dateOnly } from 'common/helpers';

class ApiTrips {
  private readonly client: ApiClient = ApiClient.getInstance();
  private static instance: ApiTrips | null = null;

  private constructor() {}

  static getInstance(): ApiTrips {
    if (ApiTrips.instance == null) {
      ApiTrips.instance = new ApiTrips();
    }

    return ApiTrips.instance;
  }

  async getById(id: string) {
    const address = createApiAddress(`/client/trips/${id}`);
    const response = await this.client.sendRequest<IClientTripFull>('get', address);
    return response;
  }

  async search(
    departureCityId: string,
    arrivalCityId: string,
    departureDate: Date,
    returnDate: Date | null | undefined
  ): Promise<IClientTripSearchFull> {
    const address = createApiAddress('/client/trips/search');

    const response = await this.client.sendRequest<IClientTripSearchFull>('get', address, {
      departureCityId: departureCityId,
      arrivalCityId: arrivalCityId,
      departureDate: dateOnly(departureDate),
      returnDate: dateOnly(returnDate),
    });

    return response;
  }

  async prices(
    departureCityId: string,
    arrivalCityId: string,
    year: number,
    month: number
  ): Promise<IClientTripMonthPricesBrief> {
    const address = createApiAddress('/client/trips/prices');
    const request = {
      departure: departureCityId,
      arrival: arrivalCityId,
      year: year,
      month: month,
    };

    const response = await this.client.sendRequest<IClientTripMonthPricesBrief>('get', address, request);
    return response;
  }
}

export default ApiTrips;
